import React, { Component } from 'react';
import { connect } from 'react-redux';

import LANGUAGES_CONTROLLER from '../../../controllers/languages';

import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('UNPROCESSED_FILES_ITEM', LOG_LEVELS.ERROR);

class UnprocessedFilesItem extends Component {
  render() {
    log.debug('render(): ', this.props);
    // Having the item know how to display a header, a 'none' row, and an actual row simplifies adding / deleting columns if we are using tables for layout.
    if (this.props.header) {
      return (
        <tr>
          <th>File name</th>
          <th>File status</th>
        </tr>
      );
    }
    return (
      <tr>
          <td><span>{this.props.document.fileName}</span></td>
        {/* the processingDate field contains the status... */}
        <td><span data-test={this.props.document.fileName}>{this.props.document.processingDate}</span></td>
      </tr>
    );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state);
  log.debug('mapStateToProps(): props', props);

  return {
    // Almost all components will need to use language strings, so add them to the props from the global state
    languages: state.languages,
  };
}


function mapDispatchersToProps(dispatch) {
  return {
    //TODO: Add dispatchers (actions we expect controllers to perform) here.
  }
}
// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(UnprocessedFilesItem);
